import axios from "axios";
import router from "./router";

const http = axios.create({
    baseURL: `${process.env.MIX_APP_URL}`,
    withCredentials: true,
});

// Error handlers
http.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error?.response?.status) {
            switch (error.response.status) {
                case 401:
                    router.push({ name: "login" });
                    break;

                default:
                    break;
            }
        }

        throw error;
    }
);

export default http;
